<script setup>
import { RouterView } from 'vue-router'
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'
</script>

<template>
  <div id="app-container">
    <NavBar />
    <main>
      <RouterView />
    </main>
    <Footer />
  </div>
</template>

<style scoped>
#app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden; /* Prevenir scroll horizontal en toda la app */
}

main {
  flex: 1;
  width: 100%;
  max-width: 100vw; /* Asegurar que no exceda el viewport */
  overflow-x: hidden;
}
</style>

